import { jsx as a, jsxs as l, Fragment as b } from "react/jsx-runtime";
import { Icon as t } from "../icon/icon.js";
import { forwardRef as n } from "react";
import { FlexBlock as s } from "../../primitives/flex-block/flex-block.js";
import m from "clsx";
import { g as f } from "../../virginmediao2-momentum-icons-icons-far-BQVtGVjv.js";
import { e as z } from "../../virginmediao2-momentum-icons-icons-fas-CfzopcU1.js";
import '../../assets/card.css';const C = "_card_1mm0z_1", y = "_card__label_1mm0z_23", h = "_card__input_1mm0z_30", r = {
  card: C,
  "card--border": "_card--border_1mm0z_11",
  "card--raised": "_card--raised_1mm0z_15",
  card__label: y,
  card__input: h,
  "card__input--active": "_card__input--active_1mm0z_30",
  "card__input--inactive": "_card__input--inactive_1mm0z_31",
  "card--sr-only": "_card--sr-only_1mm0z_48"
}, N = n(
  ({ className: c = "", layout: e, border: d, children: _, raised: i, ...p }, u) => /* @__PURE__ */ a(
    s,
    {
      ref: u,
      bg: "primary",
      "data-role": "card",
      direction: "column",
      className: m(
        {
          [r.card]: !0,
          [r["card--border"]]: !!d,
          [r["card--raised"]]: !!i,
          [r["card--full-width"]]: e === "full-width"
        },
        c
      ),
      role: "region",
      "aria-labelledby": "card",
      ...p,
      children: _
    }
  )
), B = n(
  ({ children: c, className: e = "", hidden: d = !0, ..._ }, i) => /* @__PURE__ */ l("label", { className: r.card__label, children: [
    c ? /* @__PURE__ */ a("span", { className: r["card--sr-only"], children: c }) : null,
    /* @__PURE__ */ a(
      "input",
      {
        className: m(
          r.card__input,
          {
            [r["card--sr-only"]]: !!d
          },
          e
        ),
        ..._,
        ref: i
      }
    ),
    d ? /* @__PURE__ */ l(b, { children: [
      /* @__PURE__ */ a("span", { className: r["card__input--active"], children: /* @__PURE__ */ a(t, { icon: z, color: "success", size: "lg" }) }),
      /* @__PURE__ */ a("span", { className: r["card__input--inactive"], children: /* @__PURE__ */ a(t, { icon: f, size: "lg", color: "inherit" }) })
    ] }) : null
  ] })
), o = (c) => /* @__PURE__ */ a(s, { direction: "column", ...c }), I = o, H = o, R = o;
N.displayName = "Card";
export {
  N as Card,
  H as CardBody,
  R as CardFooter,
  I as CardHeader,
  B as CardInput
};
